const downloadExcel = (file, excelName) => {
  const byteCharacters = window.atob(file);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  });
  const objectURL = window.URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = objectURL;
  anchor.download = excelName;
  anchor.click();
  URL.revokeObjectURL(objectURL);
};

const downloadPdf = (file, fileName) => {
  const binaryString = window.atob(file);
  const binaryLen = file.length;
  const bytes = new Uint8Array(binaryLen);
  for (let i = 0; i < binaryLen; i++) {
    const ascii = binaryString.charCodeAt(i);
    bytes[i] = ascii;
  }

  const pdfFile = new Blob([bytes], { type: "application/pdf" });

  const link = document.createElement("a");
  link.download = fileName || "";
  link.href = URL.createObjectURL(pdfFile);
  link.setAttribute("target", "_blank");
  link.click();
  link.remove();
};
const downloadWord = (file, excelName) => {
  const byteCharacters = window.atob(file);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], {
    type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
  });
  const objectURL = window.URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = objectURL;
  anchor.download = excelName;
  anchor.click();
  URL.revokeObjectURL(objectURL);
};

export { downloadExcel, downloadPdf, downloadWord };
